import HeaderTop from "../header";
import Footer from "../Footer/Mainfooter";
import React, { Component, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory, Link } from "react-router-dom";

import RoomCarousel from "../Havailability/RoomCarousel";
const today = moment();

const initalState = {
  dateCI: moment(),
  dateCO: moment().add(1, "days"),
  GuestAdult: 1,
  GuestChild: 0,
};
function OnChangedateCI(dateCIentered, dateCI, dateCO, setCIDate, setCODate) {
  if (
    dateCIentered.diff(today, "days") >= 0 &&
    dateCO.diff(dateCIentered, "days") > 0
  ) {
    ////console.log("here")
    setCIDate(dateCIentered);
  }
  if (dateCO.diff(dateCIentered, "days") <= 0) {
    ////console.log("here1", this.state.dateCO === initalState.dateCO)
    setCIDate((prevState) =>
      prevState.add(dateCIentered.diff(prevState, "days") + 1, "days"),
    );
    setCODate(() => dateCIentered.add(1, "days"));
  }
}

function OnChangedateCO(dateCOenter, dateCI, dateCO, setCIDate, setCODate) {
  if (dateCOenter > dateCO && dateCOenter > dateCI) {
    //dateCOenter.diff(this.state.dateCO,"days")>=0&&dateCOenter.diff(this.state.dateCI,"days")>0)
    setCODate(dateCOenter);
  } else {
    if (dateCOenter < dateCO && dateCOenter > today) {
      if (dateCOenter <= dateCI) {
        setCIDate((prevState) =>
          moment(
            prevState.dateCI.subtract(
              prevState.dateCI.diff(dateCOenter, "days") + 1,
              "days",
            ),
          ),
        );
        setCODate(dateCOenter);
      } else if (dateCOenter > dateCI) {
        setCODate(dateCOenter);
      }
    } else if (dateCOenter < dateCO && dateCOenter <= today) {
      setCIDate((prevState) =>
        dateCOenter.diff(prevState.dateCI, "days") > 0 ? today : today,
      );
      setCODate(initalState.dateCO);
    }
  }
}

const ICAL_Reservation = () => {
  const [dateCI, setCIDate] = useState(moment());
  const [dateCO, setCODate] = useState(moment().add(1, "days"));
  const [reservation_dets, setReservation_dets] = useState(null);
  const [isfound, setisFound] = useState(true);
  useEffect(() => {
    onDateselected();
    console.log(
      window.location.search.split("?")[1].split("&")[0].split("=")[1],
    ); //search.split("?")[1].split("&")[0].split("=")[1]);
  }, []);

  const onDateselected = React.useCallback(() => {
    fetch(
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000/hi"
        : "https://apiv1.reserv4me.com/hi",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          CIdate: dateCI,
          COdate: dateCO,
          ResID: window.location.search
            .split("?")[1]
            .split("&")[0]
            .split("=")[1],
        }),
      },
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("res", data);
        console.log("resonse", data.isfound);
        setisFound(data.isfound);
        window.sessionStorage.setItem("dateCI", dateCI);
        window.sessionStorage.setItem("dateCO", dateCO);
      });
  }, [dateCI, dateCO]);
  return (
    <>
      <div className="flex flex-col min-h-screen overflow-hidden">
        <HeaderTop />
        <main className="grow">
          <div className="bg-gradient-to-r from-green-400 to-blue-500  pt-20 pb-20 px-4">
            {(() => {
              if (isfound) {
                return (
                  <div>
                    <h1>Found it </h1>
                  </div>
                );
              } else {
                return (
                  <div
                    className="container justify-center mx-auto drop-shadow-xl 
                     bg-white  rounded-lg p-10 bg-opacity-75  border-blue-800
                      max-w-6xl m-10 ">
                    <div className="grid grid-cols-2 gap-4">
                      <div
                        className=" flex lg:justify-start 
                                            lg:pl-7 mb-4 col-span-2">
                        <h3 className="font-light text-2xl ">
                          Enter the Dates of your Rental:
                        </h3>
                      </div>

                      <div className="block md:flex space-x-2 justify-end  ">
                        <h4 className="font-light text-xl w-20 md:w-40 ">
                          From:
                        </h4>
                        <DatePicker
                          selected={dateCI}
                          selectsStart
                          startDate={dateCI}
                          endDate={dateCO}
                          onChange={(date) =>
                            OnChangedateCI(
                              date,
                              dateCI,
                              dateCO,
                              setCIDate,
                              setCODate,
                            )
                          }
                          id="CI"
                          className=" rounded  text-center w-full md:w-40 lg:w-60 "
                          popperModifiers={{
                            flip: {
                              behavior: ["bottom"], // don't allow it to flip to be above
                            },
                            preventOverflow: {
                              enabled: true, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                            },
                            hide: {
                              enabled: false, // turn off since needs preventOverflow to be enabled
                            },
                          }}
                        />
                      </div>
                      <div className="block md:flex space-x-2 ">
                        <h4 className="font-light text-xl w-20 md:w-40  ">
                          Until:
                        </h4>
                        <DatePicker
                          selected={dateCO}
                          selectsEnd
                          startDate={dateCI}
                          endDate={dateCO}
                          onChange={(date) =>
                            OnChangedateCO(
                              date,
                              dateCI,
                              dateCO,
                              setCIDate,
                              setCODate,
                            )
                          }
                          id="CO"
                          className="rounded  text-center w-full md:w-40 lg:w-60"
                          popperModifiers={{
                            flip: {
                              behavior: ["bottom"], // don't allow it to flip to be above
                            },
                            preventOverflow: {
                              enabled: true, // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                            },
                            hide: {
                              enabled: false, // turn off since needs preventOverflow to be enabled
                            },
                          }}
                        />
                      </div>

                      <div className="col-span-2 flex justify-end lg:pr-7 mt-4 max-w-6xl">
                        <button
                          id="btncheckavail"
                          onClick={() => {
                            onDateselected();
                          }}
                          className="font-normal text-xl bg-blue-500 text-white p-2 rounded ">
                          Find My Rental
                        </button>

                        {/* <Link
                          // to={{
                          //   //pathname: `/${this.props.Location}/${this.props.Hname}/avail`,
                          //   search: `?CIdate=${dateCI.format(
                          //     "MM/DD/YYYY"
                          //   )}&COdate=${dateCO.format(
                          //     "MM/DD/YYYY"
                          //   )}&GA=${GuestAdult}&GCH=${GuestChild}`,
                          // }}
                          >
                            <button
                              id="btncheckavail"
                              className="font-normal text-xl bg-blue-500 text-white p-2 rounded "
                            >
                              Check Availability
                            </button>
                          </Link> */}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default ICAL_Reservation;
